import { render, staticRenderFns } from "./MnoPacketItem.vue?vue&type=template&id=d94d294a&scoped=true"
import script from "./MnoPacketItem.vue?vue&type=script&lang=js"
export * from "./MnoPacketItem.vue?vue&type=script&lang=js"
import style0 from "./MnoPacketItem.vue?vue&type=style&index=0&id=d94d294a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94d294a",
  null
  
)

export default component.exports